export default __webpack_public_path__ + "static/media/contactus_parts.6577b5b1.jpg";